import { Outlet } from 'react-router-dom';
import { useMenu } from '../../context/MenuContext';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
import TermsAcceptanceModal from '../legal/TermsAcceptanceModal';

const Layout = () => {
  const { isMenuOpen } = useMenu();
  const isMobile = useIsMobile();
  const { requiresTermsAcceptance, markTermsAccepted } = useAuth();

  console.log('Layout: requiresTermsAcceptance:', requiresTermsAcceptance);

  return (
    <div className="flex h-screen bg-neutral-50">
      <Sidebar />
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ease-in-out ${
        isMobile 
          ? 'ml-0' 
          : isMenuOpen 
            ? 'ml-80' 
            : 'ml-20'
      }`}>
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-neutral-50 p-6">
          <Outlet />
        </main>
      </div>

      {/* Modal de Aceite dos Termos - só renderiza se realmente precisar */}
      {requiresTermsAcceptance && (
        <TermsAcceptanceModal
          isOpen={requiresTermsAcceptance}
          onClose={() => {}} // Não permite fechar sem aceitar
          onAccept={markTermsAccepted}
        />
      )}
    </div>
  );
};

export default Layout; 